// src/admin/api.js
const API = process.env.REACT_APP_API_BASE || "https://api.ainfotech.com.np";

async function parseResponse(res) {
  const ct = res.headers.get("content-type") || "";
  const isJSON = ct.includes("application/json");
  if (isJSON) {
    const data = await res.json();
    if (!res.ok) throw new Error(data?.error || data?.message || res.statusText);
    return data;
  }
  const text = await res.text();
  if (!res.ok) {
    const preview = text ? text.slice(0, 300) : res.statusText;
    throw new Error(`${res.status} ${res.statusText}: ${preview}`);
  }
  return text;
}

export async function apiGet(path) {
  const res = await fetch(`${API}${path}`, { credentials: "include", cache: "no-store" });
  return parseResponse(res);
}

export async function apiDel(path) {
  const res = await fetch(`${API}${path}`, { method: "DELETE", credentials: "include" });
  return parseResponse(res);
}

export async function apiPostForm(path, bodyObj) {
  const fd = new FormData();
  Object.entries(bodyObj || {}).forEach(([k, v]) => v !== undefined && v !== null && fd.append(k, v));
  const res = await fetch(`${API}${path}`, { method: "POST", credentials: "include", body: fd });
  return parseResponse(res);
}

export async function apiPutForm(path, bodyObj) {
  const fd = new FormData();
  Object.entries(bodyObj || {}).forEach(([k, v]) => v !== undefined && v !== null && fd.append(k, v));
  const res = await fetch(`${API}${path}`, { method: "PUT", credentials: "include", body: fd });
  return parseResponse(res);
}

export async function apiPostJSON(path, body) {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });
  return parseResponse(res);
}

export async function apiPutJSON(path, body) {
  const res = await fetch(`${API}${path}`, {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });
  return parseResponse(res);
}

// NEW: easy logout
export async function apiLogout() {
  return apiPostJSON("/api/auth/logout", {});
}

export const API_BASE = API;
